const deleteChecklistBySiteStr = {
  toastr: '¡La checklist fue eliminada!'
};

export default deleteChecklistBySiteStr;
